import React, { useEffect, useState, useCallback } from 'react';
import { Button, Form, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faRefresh } from '@fortawesome/free-solid-svg-icons';

interface ProcessoEmBloqueio {
  id: string;
  numeroProposta: string;
  proposta: number;
  idUsuario: number;
  atividade: string;
  dataBloqueio: string;
  acoes: boolean;
}

function TabelaProcessosBloqueados() {
  const [processos, setProcessos] = useState<ProcessoEmBloqueio[]>([]);
  const [termoBusca, setTermoBusca] = useState('');
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [filtrosVisiveis, setFiltrosVisiveis] = useState(false);

  const baseUrl = process.env.REACT_APP_ESTEIRA_BACK

  const fetchProcessos = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    const url = `${baseUrl}/api/processos-em-bloqueio/buscar?filtro=${encodeURIComponent(termoBusca)}`;

    try {
      // console.log("Buscando dados na URL:", url);
      const response = await fetch(url);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Erro na resposta da rede: ${response.status} - ${errorText}`);
      }

      const data: ProcessoEmBloqueio[] = await response.json();
      setProcessos(data);
    } catch (err: any) {
      console.error("Falha ao buscar processos:", err);
      setError(`Não há processos Bloqueados`);
      setProcessos([]);
    } finally {
      setIsLoading(false);
    }
  }, [termoBusca]);

  useEffect(() => {
    fetchProcessos();
  }, [fetchProcessos]);

  const handleDesbloquearProposta = async (numeroProposta: string) => {
    if (!numeroProposta) {
      console.error("Erro: número da proposta é indefinido. Não é possível desbloquear.");
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetch(
        `${baseUrl}/rest/propostaController/limpar-analista-por-numero-proposta?numeroProposta=${encodeURIComponent(numeroProposta)}`,
        {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        }
      );
      if (!response.ok) {
        throw new Error(`Erro ao desbloquear: ${response.statusText}`);
      }
      await fetchProcessos();
    } catch (err: any) {
      setError(`Erro ao desbloquear proposta: ${err.message}.`);
    } finally {
      setIsLoading(false);
    }
  };

  const limparFiltro = () => {
    setTermoBusca('');
  };

  return (
    <div className="m-md-3">
      <div style={{ marginBottom: '10px' }}>
        <Button 
          id="App-button-cor-principal-escura" 
          onClick={() => setFiltrosVisiveis(!filtrosVisiveis)}
        >
          <FontAwesomeIcon icon={faFilter} style={{ marginRight: '10px' }} />
          Filtros
        </Button>
      </div>

      {filtrosVisiveis && (
        <div className="p-3 mb-3 border rounded bg-light">
          <Row className="align-items-end">
            <Form.Group as={Col} md="10">
              <Form.Label>Buscar por Proposta, Usuário, Atividade ou Data</Form.Label>
              <Form.Control
                type="text"
                value={termoBusca}
                onChange={e => setTermoBusca(e.target.value)}
                placeholder="Digite o que deseja buscar..."
              />
            </Form.Group>
            <Form.Group as={Col} md="2">
              <Button onClick={limparFiltro} variant="secondary" className="w-100">
                <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '8px' }} />
                Limpar
              </Button>
            </Form.Group>
          </Row>
        </div>
      )}
      <div className="table-responsive">
        <table id="App-reponsive-text" className="table table-bordered table-striped" style={{ width: '100%' }}>
          <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
            <tr className="GridHeaderStyle">
              <th id="App-header-table">Proposta</th>
              <th id="App-header-table">Usuário</th>
              <th id="App-header-table">Atividade</th>
              <th id="App-header-table">Data Do Bloqueio</th>
              <th id="App-header-table">Ações</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr><td colSpan={5} className="text-center p-3">Carregando...</td></tr>
            ) : error ? (
              <tr><td colSpan={5} className="text-center p-3 text-danger">{error}</td></tr>
            ) : processos.length === 0 ? (
              <tr><td colSpan={5} className="text-center p-3">Nenhum registro encontrado.</td></tr>
            ) : (
              processos.map((processo) => (
                <tr className="GridRowStyle" key={processo.id}>
                  <td>{processo.numeroProposta}</td>
                  <td>{processo.idUsuario || 'N/A'}</td>
                  <td>{processo.atividade}</td>
                  <td>{new Date(processo.dataBloqueio).toLocaleDateString('pt-BR')}</td>
                  <td className="text-center">
                    {processo.acoes ? (
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDesbloquearProposta(processo.numeroProposta)}
                        disabled={isLoading}
                      >
                        Desbloquear
                      </button>
                    ) : (
                      "N/A"
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TabelaProcessosBloqueados;
